import { takeLatest, all, put, call, select } from 'redux-saga/effects';
import { enums } from 'console-kit';

import { User } from 'common-entities';

import ConsoleAppActions from '../../App/redux/app-actions';
import AccountActions from './account-actions';
import AccountModel from './account-model';
import AccountApi from './account-api';

function* fetchCurrentAccountHandler() {
  try {
    /**
     * Previously this made a call to AccountApi.fetchCurrentAccount, but that call is presently blocked for the User role which causes an issue for gateKeeper.
     * While we figure out proper permissioning around this endpoint we will continue to use the global account, but are wrapping it with a Model to minimize the direct dependency on the global.
     */
    const account = AccountModel.deserialize(App.globalContext.account);
    yield put(AccountActions.fetchCurrentAccountSuccess(account));

    if (yield select(User.Selectors.isAdmin)) {
      // currently account API data is only used to receive the privateApikey (available for Admins only)
      yield put(AccountActions.fetchAccountApiData(account));
    }
  } catch (error) {
    yield put(AccountActions.fetchCurrentAccountFailure(error));
  }
}

/**
 * Fetch additional account details from the API, that are not included in the global account object, such as apikeys.
 */
function* fetchAccountApiDataHandler() {
  const response = yield call(AccountApi.fetchCurrentAccount);
  if (response.error) yield put(AccountActions.fetchAccountApiDataFailure(response.error));
  else yield put(AccountActions.fetchAccountApiDataSuccess(response));
}

function* fetchRelativeAccountsHandler() {
  const response = yield call(AccountApi.fetchRelativeAccounts);
  if (response.error) yield put(AccountActions.fetchRelativeAccountsFailure(response.error));
  else yield put(AccountActions.fetchRelativeAccountsSuccess(response));
}

function* saveCurrentAccountHandler({ payload: { accountSettings } }) {
  const response = yield call(AccountApi.updateAccount, accountSettings);

  if (response.error) {
    yield put(AccountActions.saveCurrentAccountFailure(response.error));
  } else {
    yield put(
      ConsoleAppActions.setAlertMessage({
        messageType: enums.messageTypes.SUCCESS,
        header:      'Success',
        byline:      response.successMessage,
      })
    );
    yield put(AccountActions.saveCurrentAccountSuccess(response.account));
  }
}

export default function* accountSagas() {
  yield all([takeLatest(AccountActions.saveCurrentAccount.getType(), saveCurrentAccountHandler)]);
  yield all([takeLatest(AccountActions.fetchCurrentAccount.getType(), fetchCurrentAccountHandler)]);
  yield all([takeLatest(AccountActions.fetchRelativeAccounts.getType(), fetchRelativeAccountsHandler)]);
  yield all([takeLatest(AccountActions.fetchAccountApiData.getType(), fetchAccountApiDataHandler)]);
}
